import { Modal, Button, Form, Row, Col, Container } from "react-bootstrap";
// import UploadDocumentComponent from "./UploadDocumentComponent";
import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import US_STATES from "../../constants/states";
import COUNTIES from "../Counties";
import JSZip from "jszip";
import "./UploadDocumentModal.css";

const categoryRequirements = {
  general: ["expirationDate"],
  state: ["expirationDate", "state"],
  county: ["expirationDate", "state", "county"],
  property: ["expirationDate", "state", "county", "propertyId"],
  SB156: ["expirationDate"],
  sri: ["expirationDate", "state", "county"],
  "personal property": ["expirationDate", "state", "county", "propertyId"],
  tax: ["state", "county"]
};

const DOCUMENT_CATEGORIES = [
  { value: "County", label: "County" },
  { value: "General", label: "General" },
  { value: "Personal Property", label: "Personal Property" },
  { value: "Sale", label: "Sale" },
  { value: "SB156", label: "SB156" },
  { value: "SRI", label: "SRI" },
  { value: "State", label: "State" },
  { value: "Tax", label: "Tax" },
];

const DOCUMENT_TYPES = [
  { value: "CountyDocs", label: "County Documents" },
  { value: "GenDocs", label: "General Documents" },
  { value: "Image", label: "Image" },
  { value: "PersonalDocs", label: "Personal Property Documents" },
  { value: "SaleDocs", label: "Sale Documents" },
  { value: "sb156", label: "SB156" },
  { value: "SRIDocs", label: "SRI Documents" },
  { value: "StateDocs", label: "State Documents" },
  { value: "TaxDocs", label: "Tax Documents" },
];

const SALE_TYPES = [
  "Adjudicated Sale",
  "Blighted",
  "Certificate Sale",
  "Deed Sale",
  "Foreclosure Sale",
  // "Personal Property Sale", // Commented out based on previous code
  "Redemption",
  "Tax Lien Sale",
  "Tax Sale"
];

const UploadDocumentModal = ({ show, onHide, onUploadSuccess, setShowToast, setToastInfo }) => {
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadContainerName, setUploadContainerName] = useState("qa-container");
  const [uploadCategory, setUploadCategory] = useState("");
  const [uploadExpirationDate, setUploadExpirationDate] = useState();
  const [uploadState, setUploadState] = useState("");
  const [uploadCounty, setUploadCounty] = useState("");
  const [uploadSaleDate, setUploadSaleDate] = useState();
  const [uploadPropertyIds, setUploadPropertyIds] = useState([]);

  const [uploadSaleType, setUploadSaleType] = useState("");
  const [uploadDocType, setUploadDocType] = useState("");
  const [uploadSaleId, setUploadSaleId] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");

  const [validated] = useState(false);

  const fileInputRef = useRef(null);

  const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
  const API_KEY = process.env.REACT_APP_SERVER_API_KEY;

  const countyContainer = process.env.REACT_APP_COUNTY_CONTAINER;
  const generalContainer = process.env.REACT_APP_GENERAL_CONTAINER;
  const imageContainer = process.env.REACT_APP_IMAGE_CONTAINER;
  const saleContainer = process.env.REACT_APP_SALE_CONTAINER;
  const sb156Container = process.env.REACT_APP_SB156_CONTAINER;
  const sriContainer = process.env.REACT_APP_SRI_CONTAINER;
  const stateContainer = process.env.REACT_APP_STATE_CONTAINER;
  const taxContainer = process.env.REACT_APP_TAX_CONTAINER;
  const personalContainer = process.env.REACT_APP_PERSONAL_CONTAINER;

  useEffect(() => {
    setUploadCounty(""); // Reset county when state changes
  }, [uploadState]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setUploadFile(selectedFile);

    if (!/\.zip$/i.test(selectedFile.name)) {
      setUploadPropertyIds([uploadPropertyIds[0]]);
    } else {
      processZipFile(selectedFile);
    }
  };

  const processZipFile = async (file) => {
    const zip = new JSZip();
    await zip.loadAsync(file);
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!uploadFile) {
      alert("Please select a file.");
      return;
    }

    // Conditional validation for Expiration Date
    if (uploadCategory !== "SB156" && !uploadExpirationDate) {
      alert("Expiration Date is required for the selected category.");
      return;
    }

    // console.log("Uploading with Sale ID:", uploadSaleId); // Debug log

    let uploadResponses = [];
    const isZipFile = /\.zip$/i.test(uploadFile.name);

    const appendFormData = (fileContent, fileName) => {
      const formData = new FormData();
      formData.append("file", fileContent, fileName);

      const propertyId = isZipFile ? findMatchingPropertyId(fileName) : uploadPropertyIds[0];
      formData.append("propertyId", propertyId);
      formData.append("category", uploadCategory);
      formData.append("docType", uploadDocType);

      // Conditionally append expirationDate
      if (uploadCategory !== "SB156") {
        formData.append("expirationDate", uploadExpirationDate.toISOString().split("T")[0]);
      }

      formData.append("state", uploadState);
      formData.append("county", uploadCounty);
      formData.append("saleType", uploadSaleType);
      formData.append("saleId", uploadSaleId);
      formData.append("saleDate", uploadSaleDate ? uploadSaleDate.toISOString().split("T")[0] : '');
      return formData;
    };

    const uploadFileToServer = async (formData) => {
      try {
        await axios.post(`${API_BASE_URL}/blob/${uploadContainerName}/blob`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-api-key": API_KEY,
          },
        });
        const successMessage = `Upload successful for Property ID: ${formData.get(
          "propertyId"
        )}, Sale ID: ${formData.get("saleId")}`;
        uploadResponses.push(successMessage);
        setToastInfo({
          header: "File Uploaded Successfully",
          body: successMessage,
          variant: "warning"
        });
        setShowToast(true);
      } catch (error) {
        const errorMessage = `Upload failed for Property ID: ${formData.get("propertyId")}, Sale ID: ${formData.get(
          "saleId"
        )}`;
        uploadResponses.push(errorMessage);
        setToastInfo({
          header: "File Upload Error",
          body: errorMessage,
          variant: "danger"
        });
        setShowToast(true);
        console.error("Error uploading file:", error);
      }
    };

    if (isZipFile) {
      const zip = new JSZip();
      const content = await zip.loadAsync(uploadFile);
      for (const fileName in content.files) {
        if (content.files[fileName].dir) continue;

        const fileContent = await content.files[fileName].async("blob");
        const formData = appendFormData(fileContent, fileName);
        await uploadFileToServer(formData);
      }
    } else {
      const formData = appendFormData(uploadFile, uploadFile.name);
      await uploadFileToServer(formData);
    }

    setUploadStatus(uploadResponses.join(", "));

    // >>>>>>>>> NEW LINE TO TRIGGER REFRESH <<<<<<<<
    if (uploadResponses.length > 0 && onUploadSuccess) {
      onUploadSuccess();
    }
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

    // Reset form and hide toast after 5 seconds
    setTimeout(() => {
      setUploadFile(null);
      setUploadContainerName("qa-container");
      setUploadCategory("");
      setUploadExpirationDate(new Date());
      setUploadState("");
      setUploadCounty("");
      setUploadSaleDate(new Date());
      setUploadPropertyIds([]);
      setUploadSaleType("");
      setUploadDocType("");
      setUploadSaleId("");
      setUploadStatus("");
      setShowToast(false);
      setToastInfo({
        header: "",
        body: ""
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }, 5000);
  };

  const findMatchingPropertyId = (fileName) => {
    return uploadPropertyIds.find((id) => fileName.includes(id)) || "Unknown";
  };

  const handleDocTypeChange = (e) => {
    setUploadDocType(e.target.value);
    switch (e.target.value) {
      case "CountyDocs":
        setUploadContainerName(countyContainer);
        break;
      case "GenDocs":
        setUploadContainerName(generalContainer);
        break;
      case "Image":
        setUploadContainerName(imageContainer);
        break;
      case "PersonalDocs":
        setUploadContainerName(personalContainer);
        break;
      case "SaleDocs":
        setUploadContainerName(saleContainer);
        break;
      case "sb156":
        setUploadContainerName(sb156Container);
        break;
      case "SRIDocs":
        setUploadContainerName(sriContainer);
        break;
      case "StateDocs":
        setUploadContainerName(stateContainer);
        break;
      case "TaxDocs":
        setUploadContainerName(taxContainer);
        break;
      default:
        setUploadContainerName(generalContainer);
    }
  };

  const isRequired = (inputName) => {
    if (!uploadCategory) {
      return false;
    }
    const requirements = categoryRequirements[uploadCategory.toLocaleLowerCase()] || [];
    return requirements.includes(inputName) ? true : false;
  };

  const isFormValid = () => {
    if (!uploadFile || !uploadCategory || !uploadDocType) return false;
    
    const requirements = categoryRequirements[uploadCategory.toLocaleLowerCase()] || [];
    
    if (requirements.includes("expirationDate") && !uploadExpirationDate) return false;
    if (requirements.includes("state") && !uploadState) return false;
    if (requirements.includes("county") && !uploadCounty) return false;
    if (requirements.includes("propertyId") && (!uploadPropertyIds[0] || uploadPropertyIds[0] === '')) return false;
    if (uploadCategory !== "SB156" && !uploadSaleDate) return false;
    if (requirements.includes("expirationDate") && uploadCategory && !uploadExpirationDate) return false;
    if (uploadCategory && uploadCategory !== "SB156" && !uploadSaleDate) return false;
    
    return true;
};

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {/*
          IMPORTANT: Pass onUploadSuccess to UploadDocumentComponent
        */}
        <div className="uploadDocument documentModal">
          <div
            style={{
              backgroundColor: "#FF6D40",
              color: "white",
              textAlign: "center",
              fontWeight: "bold",
              padding: "10px 0",
            }}
          >
            <h2>Upload Documents</h2>
          </div>
          <div style={{ width: "100%", overflowY: "auto" }}>
            <Container className="m-0">
              <Form className="uploadBox" onSubmit={handleUpload} id="uploadDocumentForm">
                <Form.Group className="uploadGroup" controlId="uploadFormFile">
                  <Form.Label>
                    File (single or zip of <b>same filetype</b> only)
                  </Form.Label>
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    name="uploadFormFile"
                    ref={fileInputRef}
                    required
                  />
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormCategory">
                      <Form.Label>Category (Required)</Form.Label>
                      <Form.Control
                        as="select"
                        value={uploadCategory}
                        onChange={(e) => setUploadCategory(e.target.value)}
                        required
                        name="uploadFormCategory"
                      >
                        <option value="">Select a category</option>
                        {DOCUMENT_CATEGORIES.map((cat) => (
                          <option key={cat.value} value={cat.value}>
                            {cat.label}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormDocType">
                      <Form.Label>Location (Required)</Form.Label>
                      <Form.Control
                        as="select"
                        value={uploadDocType}
                        onChange={handleDocTypeChange}
                        required
                        name="uploadFormDocType"
                      >
                        <option value="">Select a Container</option>
                        {DOCUMENT_TYPES.map((type) => (
                          <option key={type.value} value={type.value}>
                            {type.label}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormSaleDate">
                      <Form.Label>Sale Date {isRequired("saleDate") ? "(Required)" : ""}</Form.Label>
                        <div className={uploadCategory && uploadDocType && uploadCategory !== "SB156" && !uploadSaleDate ? "is-invalid-datepicker" : ""}>
                            <DatePicker
                                name="uploadFormSaleDate"
                                selected={uploadSaleDate}
                                onChange={(date) => setUploadSaleDate(date)}
                                dateFormat="yyyy-MM-dd"
                                className={`form-control${uploadCategory && uploadDocType && uploadCategory !== "SB156" && !uploadSaleDate ? " is-invalid" : ""}`}
                                required={isRequired("saleDate")}
                                id="uploadFormSaleDate"
                            />
                        </div>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormExpirationDate">
                      <Form.Label>Expiration Date {isRequired("expirationDate") ? "(Required)" : ""}</Form.Label>
                      <div className={isRequired("expirationDate") && uploadCategory && uploadDocType && !uploadExpirationDate ? "is-invalid-datepicker" : ""}>
                        <DatePicker
                          name="uploadFormExpirationDate"
                          selected={uploadExpirationDate}
                          onChange={(date) => setUploadExpirationDate(date)}
                          dateFormat="yyyy-MM-dd"
                          className={`form-control${isRequired("expirationDate") && uploadCategory && uploadDocType && !uploadExpirationDate ? " is-invalid" : ""}`}
                          required={isRequired("expirationDate")}
                          id="uploadFormExpirationDate"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormState">
                      <Form.Label>State {isRequired("state") ? "(Required)" : ""}</Form.Label>
                      <Form.Control
                        name="uploadFormState"
                        as="select"
                        value={uploadState}
                        onChange={(e) => setUploadState(e.target.value)}
                        required={isRequired("state")}
                        isInvalid={isRequired("state") && !uploadState}
                      >
                        <option value="">Select State</option>
                        {US_STATES.map((state) => (
                          <option key={state.code} value={state.code}>
                            {state.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormCounty">
                      <Form.Label>County {isRequired("county") ? "(Required)" : ""}</Form.Label>
                      <Form.Control
                        name="uploadFormCounty"
                        as="select"
                        value={uploadCounty}
                        onChange={(e) => setUploadCounty(e.target.value)}
                        required={isRequired("county")}
                        isInvalid={isRequired("county") && !uploadCounty}
                      >
                        <option value="">Select County</option>
                        {COUNTIES[uploadState]?.map((county) => (
                          <option key={county.code} value={county.code}>
                            {county.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormSaleType">
                      <Form.Label>Sale Type {isRequired("saleType") ? "(Required)" : ""}</Form.Label>
                      <Form.Control
                        name="uploadFormSaleType"
                        as="select"
                        value={uploadSaleType}
                        onChange={(e) => setUploadSaleType(e.target.value)}
                        required={isRequired("saleType")}
                      >
                        <option value="">Select Sale Type</option>
                        {SALE_TYPES.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="uploadGroup" controlId="uploadFormSaleId">
                      <Form.Label>Sale ID {isRequired("saleId") ? "(Required)" : ""}</Form.Label>
                      <Form.Control
                        name="uploadFormSaleId"
                        type="text"
                        placeholder="Enter sale ID"
                        value={uploadSaleId}
                        onChange={(e) => setUploadSaleId(e.target.value)}
                        required={isRequired("saleId")}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="uploadGroup" controlId="uploadFormPropertyIds">
                  <Form.Label>Property IDs {isRequired("propertyId") ? "(Required)" : ""}</Form.Label>
                  <Form.Control
                    name="uploadFormPropertyIds"
                    as="textarea"
                    placeholder="Enter property IDs, comma-separated"
                    value={Array.isArray(uploadPropertyIds) ? uploadPropertyIds.join(", ") : ""}
                    onChange={(e) => setUploadPropertyIds(e.target.value.split(",").map((id) => id.trim()))}
                    required={isRequired("propertyId")}
                    isInvalid={isRequired("propertyId") && !uploadPropertyIds[0] || uploadPropertyIds[0] === ''}
                  />
                </Form.Group>
                {uploadStatus && <p>{uploadStatus}</p>}
              </Form>
            </Container>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit" form="uploadDocumentForm" disabled={!isFormValid()}>
          Upload
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadDocumentModal;
